import { render, staticRenderFns } from "./IconEtc.vue?vue&type=template&id=13421b71&"
import script from "./IconEtc.vue?vue&type=script&lang=js&"
export * from "./IconEtc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports